var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"emojiPicker active"},[_c('Picker',{ref:"picker",staticClass:"picker",attrs:{"data":_vm.emojiIndex,"set":"google","native":_vm.OS !== 'Windows',"title":_vm.emojiMartI18n.title + '...',"i18n":_vm.emojiMartI18n},on:{"select":_vm.addEmoji}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }